{
  "records.open_status": "Open",
  "periods.open_boundary": "Open ended",
  "routines.reminder_on": "On"
}
